"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTitleFontStyle = exports.FormBackgroundTheme = exports.BannerAnalysisGrade = exports.BannerSource = exports.CampaignTodoDisabledBy = exports.CampaignTodoKeys = exports.LIVE_EDITOR_STEP_KEYS = exports.FormErrors = void 0;
exports.isAnimatedBackgroundTheme = isAnimatedBackgroundTheme;
exports.isStaticShapesTheme = isStaticShapesTheme;
exports.resolveBackgroundThemeCategory = resolveBackgroundThemeCategory;
exports.parseFormBackgroundTheme = parseFormBackgroundTheme;
exports.isFormTitleFontStyle = isFormTitleFontStyle;
exports.parseFormTitleFontStyle = parseFormTitleFontStyle;
var FormErrors;
(function (FormErrors) {
    FormErrors["FormDeleted"] = "FormDeleted";
})(FormErrors || (exports.FormErrors = FormErrors = {}));
exports.LIVE_EDITOR_STEP_KEYS = [
    "campaign-life-cycle",
    "title",
    "date",
    "location",
    "fundraising-goal",
    "prizes",
    "description",
    "color",
    "banner",
    "logo",
    "order-fulfillment",
    "suggested-donation-amounts",
    "tickets",
    "questions",
    "add-donation",
    "add-ons",
    "tax-receipts",
    "discount-codes",
    "business-model",
    "e-ticket",
    "thank-you-email",
    "thank-you-email-not-winner",
    "automated-communications",
    "quickbooks-mapping",
    "advanced-settings",
    "review",
    "p2p-settings",
];
var CampaignTodoKeys;
(function (CampaignTodoKeys) {
    CampaignTodoKeys["Share"] = "share";
    CampaignTodoKeys["FirstPayments"] = "first_payments";
    CampaignTodoKeys["SmartInvite"] = "smart_invite";
    CampaignTodoKeys["TapToPay"] = "tap_to_pay";
    CampaignTodoKeys["IncompletePayments"] = "incomplete_payments";
    CampaignTodoKeys["FollowUp"] = "follow_up";
    CampaignTodoKeys["Blast"] = "blast";
    CampaignTodoKeys["CheckinTour"] = "checkin_tour";
    CampaignTodoKeys["PostEvent"] = "post_event";
})(CampaignTodoKeys || (exports.CampaignTodoKeys = CampaignTodoKeys = {}));
var CampaignTodoDisabledBy;
(function (CampaignTodoDisabledBy) {
    CampaignTodoDisabledBy["AUTO"] = "auto";
    CampaignTodoDisabledBy["USER"] = "user";
})(CampaignTodoDisabledBy || (exports.CampaignTodoDisabledBy = CampaignTodoDisabledBy = {}));
var BannerSource;
(function (BannerSource) {
    BannerSource["DefaultImage"] = "bannerDefaultImage";
    BannerSource["CustomImage"] = "customImage";
    BannerSource["UnsplashImage"] = "unsplashImage";
    BannerSource["ZeffyLibraryImage"] = "zeffyLibraryImage";
})(BannerSource || (exports.BannerSource = BannerSource = {}));
var BannerAnalysisGrade;
(function (BannerAnalysisGrade) {
    BannerAnalysisGrade["Excellent"] = "excellent";
    BannerAnalysisGrade["Good"] = "good";
    BannerAnalysisGrade["Average"] = "average";
    BannerAnalysisGrade["Poor"] = "poor";
})(BannerAnalysisGrade || (exports.BannerAnalysisGrade = BannerAnalysisGrade = {}));
/**
 * All possible background themes for donation forms, ticketings, and organization pages.
 * Animated backgrounds are canvas-based animations; static shapes are SVG decorations.
 * Values are mutually exclusive — a form can have at most one active background theme.
 */
var FormBackgroundTheme;
(function (FormBackgroundTheme) {
    // Animated backgrounds
    FormBackgroundTheme["Sparkles"] = "sparkles";
    FormBackgroundTheme["Hearts"] = "hearts";
    FormBackgroundTheme["Connectors"] = "connectors";
    FormBackgroundTheme["Music"] = "music";
    FormBackgroundTheme["Cards"] = "cards";
    FormBackgroundTheme["Faith"] = "faith";
    FormBackgroundTheme["Sports"] = "sports";
    FormBackgroundTheme["Fall"] = "fall";
    FormBackgroundTheme["Winter"] = "winter";
    FormBackgroundTheme["GivingTuesday"] = "giving_tuesday";
    FormBackgroundTheme["Pride"] = "pride";
    // Static shape themes (category-based)
    FormBackgroundTheme["Abstract"] = "abstract";
    FormBackgroundTheme["Education"] = "education";
    FormBackgroundTheme["CultureAndArts"] = "culture_and_arts";
    FormBackgroundTheme["Religion"] = "religion";
    FormBackgroundTheme["Animal"] = "animal";
    FormBackgroundTheme["Environment"] = "environment";
    FormBackgroundTheme["Golf"] = "golf";
    FormBackgroundTheme["Health"] = "health";
    FormBackgroundTheme["Humanitarian"] = "humanitarian";
})(FormBackgroundTheme || (exports.FormBackgroundTheme = FormBackgroundTheme = {}));
const ANIMATED_BACKGROUND_THEMES = new Set([
    FormBackgroundTheme.Sparkles,
    FormBackgroundTheme.Hearts,
    FormBackgroundTheme.Connectors,
    FormBackgroundTheme.Music,
    FormBackgroundTheme.Cards,
    FormBackgroundTheme.Faith,
    FormBackgroundTheme.Sports,
    FormBackgroundTheme.Fall,
    FormBackgroundTheme.Winter,
    FormBackgroundTheme.GivingTuesday,
    FormBackgroundTheme.Pride,
]);
const STATIC_SHAPES_THEMES = new Set([
    FormBackgroundTheme.Abstract,
    FormBackgroundTheme.Education,
    FormBackgroundTheme.CultureAndArts,
    FormBackgroundTheme.Religion,
    FormBackgroundTheme.Animal,
    FormBackgroundTheme.Environment,
    FormBackgroundTheme.Golf,
    FormBackgroundTheme.Health,
    FormBackgroundTheme.Humanitarian,
]);
const ALL_BACKGROUND_THEME_VALUES = new Set(Object.values(FormBackgroundTheme));
function isAnimatedBackgroundTheme(theme) {
    return ANIMATED_BACKGROUND_THEMES.has(theme);
}
function isStaticShapesTheme(theme) {
    return STATIC_SHAPES_THEMES.has(theme);
}
function resolveBackgroundThemeCategory(theme) {
    if (!theme) {
        return "simple";
    }
    if (isAnimatedBackgroundTheme(theme)) {
        return "animated";
    }
    if (isStaticShapesTheme(theme)) {
        return "static";
    }
    return "simple";
}
function parseFormBackgroundTheme(raw) {
    if (!raw) {
        return null;
    }
    const normalized = raw.trim().toLowerCase();
    return ALL_BACKGROUND_THEME_VALUES.has(normalized) ? normalized : null;
}
var FormTitleFontStyle;
(function (FormTitleFontStyle) {
    FormTitleFontStyle["Classic"] = "classic";
    FormTitleFontStyle["Elegant"] = "elegant";
    FormTitleFontStyle["Handwritten"] = "handwritten";
    FormTitleFontStyle["SlabSerif"] = "slabSerif";
    FormTitleFontStyle["Futuristic"] = "futuristic";
    FormTitleFontStyle["Bubbly"] = "bubbly";
})(FormTitleFontStyle || (exports.FormTitleFontStyle = FormTitleFontStyle = {}));
const ALL_FONT_STYLE_VALUES = new Set(Object.values(FormTitleFontStyle));
function isFormTitleFontStyle(value) {
    return ALL_FONT_STYLE_VALUES.has(value);
}
function parseFormTitleFontStyle(raw) {
    if (!raw || !isFormTitleFontStyle(raw)) {
        return null;
    }
    return raw;
}
